import {getDictData,getMoreDictData} from '@/services/model/common';

export default {
  methods: {
    // 通用获取枚举方法
    async queryDict(enumName, model) {
      const {data} = await getDictData({enumName})
      this[model] = data || []
      return data || []
    },
    // 通用获取多个枚举方法 enumName是枚举名称数组，model是枚举名称对于的list名称数字
    // 如 enumName = ['枚举1','枚举2'] ; model = ['枚举1对应的变量名称','枚举2对应的变量名称']
    async queryDictList(enumNameList, modelList) {
      let enumName = enumNameList.join(',')
      const {data} = await getMoreDictData({enumName})
      for(let i=0;i<enumNameList.length;i++){
        data.map(x => {
          if(x.enumName === enumNameList[i]){
            let modelName = modelList[i]
            this[modelName] = x.list || []
          }
        })
      }
    },
  },
}
